const oursAboutPegasus = {
  title: 'OUR APPROACH',
  cards: {
    reliability: {
      title: 'RELIABILITY',
      description:
        'Every UAV undergoes strict testing before being deployed to the units.',
    },
    fast: {
      title: 'SPEED OF IMPLEMENTATION',
      description: 'From concept to mass production — just a few months.',
    },
    stability: {
      title: 'EW RESISTANCE',
      description:
        'We provide solutions able to operate under the most adverse conditions.',
    },
    locked: {
      title: 'CLOSED ECOSYSTEM',
      description:
        'End-to-end solutions: from R&D and production to UAV/UAS operator training and 24/7 technical support.',
    },
  },
}

export default oursAboutPegasus
